import axios from "axios";

// Constants
const SET_TEMPORARY_PASSWORD = "SET_TEMPORARY_PASSWORD";
const CLEAR_TEMPORARY_PASSWORD = "CLEAR_TEMPORARY_PASSWORD";
const LOGOUT = "LOGOUT";

// Acessors
const getTemporaryPassword = (state) => state?.temporaryPassword;
const getExpiresIn = (state) => state?.expiresIn;

// Default state
const initialState = {
  temporaryPassword: null,
  expiresIn: null,
};

export const temporaryPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TEMPORARY_PASSWORD:
      return {
        ...state,
        temporaryPassword: action.token,
        expiresIn: action.expiresIn, //minutes
      };
    case CLEAR_TEMPORARY_PASSWORD:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const generateTemporaryPassword = (participantId) => async (dispatch) => {
  const body = {
    participantId: participantId,
  };

  return axios
    .put(`/api/participant/generatetoken`, body)
    .then(({ data }) => {
      dispatch({
        type: SET_TEMPORARY_PASSWORD,
        token: data.token,
        expiresIn: data.expiresIn,
      });
    })
    .catch((e) => {
      return Promise.reject(
        e.response?.data
          ? e.response.data
          : "There was an error while trying to generate a new temporary password!"
      );
    });
};

const clearTemporaryPassword = () => (dispatch) => {
  dispatch({ type: CLEAR_TEMPORARY_PASSWORD });
};

export const mapStateToProps = (state) => {
  return {
    temporaryPassword: getTemporaryPassword(state),
    expiresIn: getExpiresIn(state),
  };
};

export const mapDispatchToProps = {
  generateTemporaryPassword,
  clearTemporaryPassword,
};
